// Mothly Consumption Report Line Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface MonthlyConsumptionReportLineChartProps {
  filteredData: Array<{
    date: string;
    kwhconsumption: number;
    [key: string]: any;
  }>;
}

const MonthlyConsumptionReportLineChart: React.FC<
  MonthlyConsumptionReportLineChartProps
> = ({ filteredData }) => {
  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      formatter: (params: any) => `
           <div style="padding: 5px; color: #fff;">
             ${params[0].name}: ${params[0].value}%
           </div>
         `,
    },
    xAxis: {
      type: "category",
      data: filteredData.map((item) => item.date),
      axisLabel: {
        color: "#5F6368",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
    },

    grid: {
      left: "2%",
      right: "2%",
      bottom: "10%",
      containLabel: true,
    },
    series: [
      {
        name: "KWH Consumption",
        type: "line",
        data: filteredData.map((item) => item.kwhconsumption),
        itemStyle: { color: "#1976d2" },
        smooth: true,
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "310px", width: "100%" }} />
  );
};

export default MonthlyConsumptionReportLineChart;
